import { useCallback, useEffect, useState } from "react";
import {
  type Lexicon,
  loadLexicon,
} from "@/lib/tool-kit/word-knowledge/vocabulary-profile";

export type LexiconStatus = "idle" | "loading" | "ready" | "error";

/**
 * The NGSL and NAWL lists the Vocabulary Profiler needs, fetched once per page load.
 * Nothing is requested until `wanted` turns true — a visitor who only reads the page
 * never downloads them. `retry` forgets a failed load and asks again.
 */
export function useLexicon(wanted: boolean) {
  const [lexicon, setLexicon] = useState<Lexicon | null>(null);
  const [status, setStatus] = useState<LexiconStatus>("idle");

  useEffect(() => {
    if (!wanted || status !== "idle") {
      return;
    }
    setStatus("loading");
    loadLexicon()
      .then((loaded) => {
        setLexicon(loaded);
        setStatus("ready");
      })
      .catch(() => setStatus("error"));
  }, [wanted, status]);

  const retry = useCallback(() => setStatus("idle"), []);
  return { lexicon, status, retry };
}
